// removed by extract-text-webpack-plugin
module.exports = {"ModalOverlay":"_3EL7fH1SqLLqhKIZFJ_8w4","ModalContainer":"_3Kz0XT7x79VzapdvX94GGL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/index.css
// module id = 492
// module chunks = 0